import { httpService } from "@/api/httpService"
const electronicFilm = {
  state: {
    seriesDataList: [
      {
        getDcmFilePath: ["wadouri:/static/img/1.dcm"]
      },
      {
        getDcmFilePath: ["wadouri:/static/img/1-2.dcm"]
      }
    ]
  },
  mutations: {
    SET_ELECTRONIC_FILM_INFO: (state, info) => {
      state.seriesDataList = info
    }
  },
  actions: {
    getElectronicFilmInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        httpService({
          url: "getElectronicFilmData",
          method: "get",
          params: params
        })
          .then((response) => {
            response.result.forEach((ele) => {
              // 区分bmp和是dcm
              if (
                ele.fileTypeName === "png" ||
                ele.fileTypeName === "jpg" ||
                ele.fileTypeName === "bmp"
              ) {
                ele.getDcmFilePath = ele.getDcmFilePath.map((_ele) => {
                  return `${location.origin}${_ele}`
                })
              } else {
                ele.getDcmFilePath = ele.getDcmFilePath.map((_ele) => {
                  return `wadouri:${_ele}`
                })
              }
            })
            commit("SET_ELECTRONIC_FILM_INFO", response.result)
            resolve(response.result)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}

export default electronicFilm
